import axios from "axios";
import { apiUrl } from "../utils/apiURL";

export const instance = axios.create({
  baseURL: apiUrl,
});
